import API from '@services/API';

const TipoPendenciaService = {

	filtrar: async (processo, filtros) => await API.filters(`${processo}/tiposPendencias`, filtros),
	listar: async (processo) => await API.list(`${processo}/tiposPendencias`),
	listarSemPaginacao: async (processo) => await API.list(`${processo}/tiposPendencias/listar`),
	listarUm: async (processo, id) => await API.find(`${processo}/tiposPendencias`, id),
  adicionar: async (processo, tipoPendencia) => await API.add(`${processo}/tiposPendencias`, tipoPendencia),
 	editar: async (processo, id, tipoPendencia) => await API.edit(`${processo}/tiposPendencias`, id, tipoPendencia),
  excluir: async (processo, id) => await API.remove(`${processo}/tiposPendencias`, id),
	verificaSePodeRemoverOpcaoResposta: async (processo, id,idResposta) => await API.get(`${processo}/tiposPendencias/${id}/respostas/${idResposta}/verificaSePodeRemover`),
	imprimirEtiqueta: async (processo, id) => await API.download(`${processo}/tiposPendencias/${id}/etiqueta`)
}

export default TipoPendenciaService;